const MAP = {
  aperto: ["Preventivo aperto", "bg-amber-50 text-amber-800 border-amber-200"],
  firmato: ["Contratto firmato", "bg-emerald-50 text-emerald-700 border-emerald-200"],
};

export function StatusBadge({ status }) {
  const [label, cls] = MAP[status] || MAP.aperto;
  return <span data-testid="status-badge" className={`shrink-0 text-[11px] font-semibold px-2.5 py-1 rounded-full border ${cls}`}>{label}</span>;
}
